/**
 * Utility functions for environment detection
 */

/**
 * Determines if the current environment is production
 * @returns {boolean} True if in production environment
 */
export const isProduction = () => {
  if (typeof window !== 'undefined') {
    return window.location.protocol === 'https:';
  }
  return process.env.NODE_ENV === 'production';
};

/**
 * Determines if the current environment is development
 * @returns {boolean} True if in development environment
 */
export const isDevelopment = () => {
  return !isProduction();
};

/**
 * Gets the current environment name
 * @returns {string} 'production' or 'development'
 */
export const getEnvironment = () => {
  return isProduction() ? 'production' : 'development';
};

/**
 * Gets the current protocol (http or https)
 * @returns {string} 'http:' or 'https:'
 */
export const getProtocol = () => {
  if (typeof window !== 'undefined') {
    return window.location.protocol;
  }
  return isProduction() ? 'https:' : 'http:';
}; 